import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import VueMarkdown from 'vue-markdown';
import { namespace } from 'vuex-class';
import MyDialog from '@/components/MyDialog.vue';
import { startCase } from 'lodash';
const referenceTableModules = namespace('referenceTables');
const powersModule = namespace('powers');
let FragmentModal = class FragmentModal extends Vue {
    constructor() {
        super(...arguments);
        this.startCase = startCase;
    }
    created() {
        this.fetchReferenceTables();
        this.fetchPowers();
    }
    get hash() {
        return decodeURI(this.$route.hash).substring(1);
    }
    get power() {
        return this.powers.find(({ name }) => name.toLowerCase() === this.hash.toLowerCase());
    }
    get content() {
        if (!this.hash)
            return '';
        const tableData = this.referenceTables.find(({ name }) => name === this.hash);
        return this.power ? this.power.description : tableData ? tableData.content : '';
    }
    get hasContent() {
        return (this.hash !== '') && (this.content !== '');
    }
    get route() {
        return ({
            ...this.$route,
            matched: [],
            hash: ''
        });
    }
    onCloseCallBack() {
        this.$router.push({
            path: this.$route.path,
            hash: ''
        });
    }
};
__decorate([
    Prop(String)
], FragmentModal.prototype, "title", void 0);
__decorate([
    referenceTableModules.State
], FragmentModal.prototype, "referenceTables", void 0);
__decorate([
    referenceTableModules.Action
], FragmentModal.prototype, "fetchReferenceTables", void 0);
__decorate([
    powersModule.State
], FragmentModal.prototype, "powers", void 0);
__decorate([
    powersModule.Action
], FragmentModal.prototype, "fetchPowers", void 0);
FragmentModal = __decorate([
    Component({
        components: {
            VueMarkdown,
            MyDialog
        }
    })
], FragmentModal);
export default FragmentModal;
